const StatsTypes = {
  OVERVIEW: 'overview',
  PREVIOUS_MEETINGS: 'previous-meetings',
  VICTORY_PROBABILITY: 'victory-probability',
  LAST_5_GAMES: 'last-5-games',
  TOP_SCORERS: 'top-scorers',
  SEASON_STATS: 'season-stats',
  GOALS: 'goals',
  OVER_GOALS: 'over-goals',
  SHOTS: 'shots',
  AVERAGE_MATCH_STATS: 'average-match-stats',
  VENUE_REFEREE: 'venue-referee',
  LAST_5_GAMES_COMPACT: 'last-5-games-compact',
  LEAGUE_TABLE: 'league-table',
  PLAYER_STATS: 'player-stats',
  LINEUP: 'lineup',
} as const;

export default StatsTypes;
